import React from 'react';
import PropTypes from 'prop-types';

const AdminReportsDataListItemDownload = ({ item }) => (
  <td className="download-link">
    <a href={`/downloads/${item.uuid}`} target="_blank" rel="noopener noreferrer">
      {item.uuid}
    </a>
  </td>
);

AdminReportsDataListItemDownload.propTypes = {
  item: PropTypes.object.isRequired,
};

export default AdminReportsDataListItemDownload;
